<div *mobxAutorun class="px-4 mb-4">
  <div class="grid w-full justify-content-end pb-1 pt-3">
    <p-dropdown
      class="col-fixed"
      [options]="metricPeriodOptions"
      [(ngModel)]="activePeriod"
      (onChange)="onActivePeriodChange()"
    ></p-dropdown>
    <p-dropdown
      styleClass="metric-range-select"
      class="col-fixed"
      [options]="metricRangeOptions"
      [(ngModel)]="activeRangeOption"
      (ngModelChange)="refreshKeyMetrics()"
      optionLabel="label"
    ></p-dropdown>
  </div>
  <div class="grid flex-wrap">
    <p-card class="col-12 md:col-6 lg:text-left">
      <div *ngIf="user" class="flex-grow-1 grid justify-content-evenly">
        <div class="col-6 flex align-items-center">
          <p-avatar
            [image]="user.profileImageUrl"
            [label]="user.initials"
            shape="circle"
            styleClass="shadow-4 border-3 border-400"
            [style]="{ 'background-color': '#012069' }"
          ></p-avatar>
        </div>
        <div class="col-6 flex align-items-center">
          <div>
            <div class="mb-4">
              <div class="font-bold greeting line-height-1">Hey, {{ user.firstName }}!</div>
              <a *ngIf="mainLink" target="_blank" class="main-link" [href]="mainLink.url"
                >{{ mainLink.text }}</a
              >
            </div>
            <div class="job-title">{{ user.jobTitle }}</div>
          </div>
        </div>
      </div>
      <div class="text-center w-full">
        <span *ngFor="let link of secondaryLinks; let i = index">
          <a class="white-space-nowrap" target="_blank" [href]="link.url">{{ link.text }}</a
          ><span *ngIf="i < secondaryLinks.length - 1"> &nbsp;|&nbsp; </span>
        </span>
      </div>
    </p-card>
    <p-card
      *ngFor="let metric of sortedKeyMetrics; let i = index;"
      [ngClass]="{ 'col-12 md:col-6': i == 0, 'col-4': i > 0 }"
      [styleClass]="i > 0 ? 'small' : ''"
    >
      <div class="flex-initial flex justify-content-between">
        <span class="md:text-lg">{{ metric.title }}</span>
        <button
          (click)="pinMetric(metric.metricType)"
          class="text-gray-500 bg-white text-sm shadow-none w-1rem h-1rem hover:text-black-alpha-90"
          [ngClass]="{ 'text-primary': i == 0 }"
          pButton
          icon="fa fa-thumb-tack"
        ></button>
      </div>
      <div class="flex-grow-1 flex justify-content-center align-items-center">
        <key-metric
          [ngStyle]="i == 0 && { 'width': '80%' }"
          [loading]="metricsLoading"
          [showTargetDifference]="true"
          [showGraph]="i == 0"
          [metric]="metric"
        >
        </key-metric>
      </div>
      <div *ngIf="i > 0" class="flex-initial font-light text-xs text-gray-500 text-right">
        {{ activeRangeOption?.label }}
      </div>
    </p-card>
  </div>
</div>
